import { request } from "utils";

export async function callGetNotificationList(params) {
  const res = await request.get('notification/list', params);
  return res;
}

export default callGetNotificationList;
